/**
 * 列表页公共逻辑
 *
 * @author  huojinzhao
 */

import { encodeQuery } from "enslaver-uri";
import { $http } from "@/utils";

function listDeleteItem(id, list, uri, header) {
  return $http.delete(`${uri}/${id}`, header)
    .then(() => {
      const index = list.findIndex(item => item.id === id);

      if (index > -1) {
        list.splice(index, 1);

        this.$alert(
          "删除成功",
          "删除确认",
          {
            confirmButtonText: "我知道了",
            type: "success",
            confirmButtonClass: "success",
          },
        );
      }
    })
    .catch(({ message }) => {
      this.$alert(
        message,
        "删除确认",
        {
          confirmButtonText: "我知道了",
          type: "warning",
          confirmButtonClass: "el-button--danger",
        },
      );
    });
}

/**
 * 确认删除Table中的某一项
 *
 * @param id          {number}    目标id
 * @param list        {Array}     目标所在数组列表
 * @param appellation {string}    目标称呼
 * @param uri         {string}    删除接口前缀
 */
function deleteAlert(id, list, appellation, uri) {
  this.$confirm(
    `确定删除该${appellation}？`,
    "删除确认",
    {
      showCancelButton: true,
      type: "warning",
      confirmButtonText: "删除",
      confirmButtonClass: "el-button--danger",
      // beforeClose,
    },
  )
    .then(() => {
      listDeleteItem.bind(this)(id, list, uri);
    })
    .catch(() => {});
}

/**
 * 密码式确认删除Table中的某一项
 *
 * @param id          {number}    目标id
 * @param list        {Array}     目标所在数组列表
 * @param message     {string}    删除提醒文案
 * @param uri         {string}    删除接口前缀
 */
function deleteCheck(id, list, message, uri) {
  this.$prompt(
    message,
    "确认删除",
    {
      inputType: "password",
      inputPlaceholder: "请输入密码",
      inputPattern: /^\S{6}\S*$/,
      inputErrorMessage: "请填写正确的密码",
      confirmButtonText: "删除",
      confirmButtonClass: "el-button--danger",
    },
  )
    .then(({ value }) => {
      const header = { CheckoutPassword: value };

      listDeleteItem.bind(this)(id, list, uri, header);
    })
    .catch(() => {});
}

// 获取列表数据
function fetch(uri, query = {}) {
  const route = { query };

  const search = encodeQuery(route);

  return $http.get(`${uri}${search}`)
    .catch((error) => {
      this.$message.error("数据请求发生错误");

      throw error;
    });
}

// 路由query处理：翻页 | 返回新的对象
function routeQuery(
  newQuery = {},
  baseQuery,
) {
  const query = baseQuery
    ? { ...baseQuery, ...newQuery }
    : { ...this.$route.query, ...newQuery };

  const targetQuery = Object.keys(query)
    .filter(qKey => query[qKey])
    .reduce((acc, key) => ({ ...acc, [`${key}`]: query[key] }), {});

  return baseQuery
    ? targetQuery : this.$router.push({ query: targetQuery });
}

// 翻页
function routePageIndex(
  page = 1,
  baseQuery,
) {
  return routeQuery.bind(this)({ page }, baseQuery);
}

// 路由query处理：翻页 | 返回新的对象 替换页面
function routeQueryType(
  newQuery = {},
  baseQuery,
) {
  const query = baseQuery
    ? { ...baseQuery, ...newQuery }
    : { ...this.$route.query, ...newQuery };

  const targetQuery = Object.keys(query)
    .filter(qKey => query[qKey])
    .reduce((acc, key) => ({ ...acc, [`${key}`]: query[key] }), {});

  return baseQuery
    ? targetQuery : this.$router.replace({ query: targetQuery });
}

// 类型翻页
function routeTypePageIndex(
  pageType,
  baseQuery,
) {
  return routeQueryType.bind(this)(pageType, baseQuery);
}

export default {
  deleteAlert,
  deleteCheck,
  fetch,
  routeQuery,
  routePageIndex,
  routeTypePageIndex,
};
